// extracted by mini-css-extract-plugin
export var assigneeBadge = "_g4-0";
export var assigneeDetails = "_g4-1";
export var assigneeInfo = "_g4-2";
export var dropdownContainer = "_g4-4";
export var dropdownImage = "_g4-5";
export var editAssigneeInfo = "_g4-3";
export var editAssigneeModalContainer = "_g4-6";
export var hidden = "_g4-8";
export var input = "_g4-7";